export const CHAR_WRAPPERS: Record<string, React.JSX.Element | string> = {
  "\u2018": (
    <span style={{ fontFamily: "Outfit, 'Outfit fallback'" }}>&#x2018;</span>
  ),
  "\u2019": (
    <span style={{ fontFamily: "Outfit, 'Outfit fallback'" }}>&#x2019;</span>
  ),
};
